import { Button } from '@/components/Button';
import { useNavigate } from '@tanstack/react-router';

interface TutorialStep3Props {
  onBack: () => void;
}

export default function TutorialStep3({ onBack }: TutorialStep3Props) {
  const navigate = useNavigate();

  return (
    <>
      {/* ステップタイトル */}
      <div className="flex items-center justify-center py-xs">
        <h2 className="text-lg leading-normal font-bold text-black/70">③ 求人の取り込み完了</h2>
      </div>

      <div className="flex justify-center p-md">
        <img src="/agent/trial/step3.png" alt="" width={424} height={272} />
      </div>

      {/* 進捗インジケーター */}
      <div className="flex h-xxl items-center justify-center gap-[11px]">
        <div className="size-[10px] rounded-full bg-primary" />
        <div className="size-[10px] rounded-full bg-primary" />
        <div className="size-[10px] rounded-full bg-primary" />
      </div>

      {/* ボタン */}
      <div className="flex justify-center gap-md py-xs">
        <Button color="secondary" size="lg" className="h-[52px] w-[200px]" onClick={onBack}>
          戻る
        </Button>
        <Button
          color="primary"
          size="lg"
          className="h-[52px] w-[240px]"
          onClick={() => {
            navigate({ to: '/agent/trial/account/link' });
          }}
        >
          連携アカウントの設定をする
        </Button>
      </div>
    </>
  );
}
